import React, { useState } from "react";
import ApiService, { setToast } from "../../../ApiService";

import {
  /* CssBaseline, */ Avatar,
  Link,
  /* Grid, */ Typography /* Container, */,
  InputLabel,
  OutlinedInput,
  FormControl,
  Box /* CircularProgress, */ /* Paper, */ /* TextField */,
} from "@mui/material";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { Alert } from "@mui/material";
import { useSnackbar } from "notistack";
import { ArrowBack } from "@material-ui/icons";
import Button from "../../../components/Custom/Button/Button";

import useStyles from "./styles";
import GridContainer from "../../../components/Custom/Grid/GridContainer";
import GridItem from "../../../components/Custom/Grid/GridItem";
/* import { Box } from "@material-ui/core"; */

export default function ForgetPassword(props) {
  var classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responsemessage, setResponsemessage] = useState("");
  const { enqueueSnackbar: showSnackbar, closeSnackbar } = useSnackbar();
  var [username, setUsername] = useState(null);
  const [txnMessageType, setTxnMessageType] = useState("");
  var [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    if (event.target.name === "username") setUsername(event.target.value);
  };

  const handleKeyPress = (ev) => {
    if (ev.key === "Enter") forgetPasswordClick();
  };

  const forgetPasswordClick = () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    setTxnMessageType("");
    setToast(showSnackbar, closeSnackbar);
    setLoading(true);
    ApiService.forgetPassword(username).then((res) => {
      if (res.data.status === "OK") {
        setTxnMessageType("success");
        setResponsemessage(res.data.responseMessage);
      } else if (res.data.status == "BAD_REQUEST") {
        setTxnMessageType("warning");
        setResponsemessage(res.data.responseMessage);
        setIsSubmitting(false);
      } else {
        setTxnMessageType("error");
        setResponsemessage(res.data.responseMessage);
        setIsSubmitting(false);
      }
    });
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={3} lg={4}></GridItem>
      <GridItem xs={12} sm={12} md={6} lg={4} style={{ marginTop: "14px" }}>
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "4px" }}
          >
            <div style={{ justifyContent: "center", display: "flex" }}>
              <Typography component="h1" variant="h5">
                Forget Password
              </Typography>
            </div>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "20px" }}
          >
            {responsemessage && (
              <Alert severity={txnMessageType || "error"} elevation="0">
                {" "}
                {responsemessage}{" "}
              </Alert>
            )}
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "4px" }}
          >
            <FormControl fullWidth>
              <InputLabel required htmlFor="username">
                User name
              </InputLabel>
              <OutlinedInput
                id="username"
                name="username"
                value={username}
                label="User Name"
                onChange={handleChange}
              />
            </FormControl>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "4px" }}
          >
            <FormControl variant="outlined" className={classes.form}>
              <Box align="center" style={{ paddingTop: 10 }}>
                <Button
                  href="/"
                  startIcon={<ArrowBack />}
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "20px" }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={forgetPasswordClick}
                  disabled={txnMessageType === "success"}
                >
                  Submit
                </Button>
              </Box>
              {/* <Button 
                      startIcon={<ArrowBack />}
                      variant="outlined"
                      color="primary"
                      style={{ marginRight: 20 }}
                    >
                      Back
                    </Button> */}
            </FormControl>
          </GridItem>

          {/* <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginTop: "4px" }}>
                            <Link href="/" variant="body2">Login</Link>
                        </GridItem> */}
        </GridContainer>
      </GridItem>
      <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginTop: "4px" }}>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Avatar
            alt="PCI"
            variant="square"
            src="pci.png"
            style={{ width: "60px", height: "60px" }}
          ></Avatar>
        </div>
      </GridItem>
    </GridContainer>
  );
}
